export default function normalizeFilterText(text) {
  // https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript {
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}
